// @flow
import React from "react"
import { Head } from "react-static"
import logo from "./favicon.png"
import sanitizeHtml from "sanitize-html"
import Entities from "html-entities"

const entities = new Entities.AllHtmlEntities()

export type tPageMeta = {
  title: string,
  subtitle?: string,
  description: string,
  image: {
    url: string,
    height: number,
    width: number
  }
}

export function PageMeta(props: tPageMeta) {
  const title = entities.decode(sanitizeHtml(props.title))
  const description = entities.decode(sanitizeHtml(props.description))

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:url" content="https://www.spiritualliving.org/" />
      <meta property="og:site_name" content="Center for Spiritual Living" />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={props.image.url} />
      <meta property="og:image:secure_url" content={props.image.url} />
      <meta property="og:image:width" content={props.image.width} />
      <meta property="og:image:height" content={props.image.height} />
      <meta name="twitter:card" content="summary_large_image" />
      {props.subtitle ? (
        <meta
          name="twitter:title"
          content={`Center for Spiritual Living \| ${props.subtitle}`}
        />
      ) : (
        <meta
          name="twitter:title"
          content={`Center for Spiritual Living \| ${title}`}
        />
      )}
      <meta name="twitter:site" content="@mycsl" />
      <meta name="twitter:image" content={logo} />
      <meta name="twitter:creator" content="@The_SeaMonsters" />
    </Head>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/PageMeta.js